import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { SetActiveArtist } from '@webapp/store/artist/action-creators';
import { SET_ACTIVE_ARTIST } from '../../artist/actions';

export const identifyArtistEpic = (action$: Observable<SetActiveArtist>) =>
  action$.pipe(
    ofType(SET_ACTIVE_ARTIST),
    map((action) => {
      if (window.analytics) {
        window.analytics.group(action.artist.id as string, {
          id: action.artist.id,
          name: action.artist.name,
          artistType: action.artist.type,
          avatar: action.artist.avatar,
          email: action.artist.email,
          phone: action.artist.telephone,
          subdomain: action.artist.shortId,
          createdAt: action.artist.created_at
            ? new Date(action.artist.created_at).toISOString()
            : undefined,
        });
      }
    }),
    filter(() => false)
  );
